import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from './cx.js';
export function LoadingState({ label = 'Loading', className }) {
    return (_jsxs("div", { className: cx('trace-auth-loading', className), role: "status", "aria-live": "polite", "aria-busy": "true", children: [_jsx("span", { className: "trace-auth-spinner", "aria-hidden": "true" }), _jsx("span", { className: "trace-auth-loading__label", children: label })] }));
}
//# sourceMappingURL=LoadingState.js.map